<template>
    <div class="overview-page-container">
        <div class="overview-left">
            <div class="overview-item">
                <div class="overview-title">近18个月充放电量</div>
                <div class="echart-wrap">
                    <v-chart
                        :auto-resize="true"
                        :autoResize="true"
                        :options="barYear18"
                        ref="barYear"
                        theme="ovilia-green"
                    />
                </div>
            </div>
            <div class="overview-item">
                <div class="overview-title">近30天实时日冲电量</div>
                <div class="echart-wrap">
                    <v-chart
                        :auto-resize="true"
                        :autoResize="true"
                        :options="barYear30"
                        ref="barYear"
                        theme="ovilia-green"
                    />
                </div>
            </div>
            <div class="overview-item">
                <div class="overview-title">实时日充放电电量</div>
                <div class="echart-wrap">
                    <v-chart
                        :auto-resize="true"
                        :autoResize="true"
                        :options="barYear"
                        ref="barYear"
                        theme="ovilia-green"
                    />
                </div>
            </div>
        </div>
        <!-- <div class="overview-middle">
            <img
                src="../../../assets/image/leaderpage/charging-pile.png"
                alt=""
                srcset=""
            />
        </div> -->
        <div class="overview-right">
            <div class="overview-item">
                <div class="overview-title">近18个月充放收益</div>
                <div class="echart-wrap">
                    <v-chart
                        :auto-resize="true"
                        :autoResize="true"
                        :options="pieOption18"
                        ref="barYear"
                        theme="ovilia-green"
                    />
                </div>
            </div>
            <div class="overview-item">
                <div class="overview-title">11月份充电收益</div>
                <div class="echart-wrap">
                    <v-chart
                        :auto-resize="true"
                        :autoResize="true"
                        :options="pieOption30"
                        ref="barYear"
                        theme="ovilia-green"
                    />
                </div>
            </div>
            <div class="overview-item">
                <div class="overview-title">11月充电桩使用与新能源对比</div>
                <div class="echart-wrap">
                    <v-chart
                        :auto-resize="true"
                        :autoResize="true"
                        :options="pieOption24"
                        ref="barYear"
                        theme="ovilia-green"
                    />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import "echarts/lib/chart/bar";
import "echarts/lib/chart/line";
import "echarts/lib/chart/pie";
import "echarts/lib/chart/bar";
import "echarts/lib/component/tooltip";
import "echarts/lib/component/title";
import "echarts/lib/component/legend";
import "echarts/lib/component/legendScroll";
import "echarts/lib/component/toolbox";
import "echarts/lib/component/markPoint";
import "echarts/lib/component/graphic";
export default {
    data() {
        return {
            time18X: [
                "2019-06",
                "2019-07",
                "2019-08",
                "2019-09",
                "2019-10",
                "2019-11",
                "2019-12",
                "2020-01",
                "2020-02",
                "2020-03",
                "2020-04",
                "2020-05",
                "2020-06",
                "2020-07",
                "2020-08",
                "2020-09",
                "2020-10",
                "2020-11"
            ],
            time30X: [],
            time24X: [
                "00:00",
                "01:00",
                "02:00",
                "03:00",
                "04:00",
                "05:00",
                "06:00",
                "07:00",
                "08:00",
                "09:00",
                "10:00",
                "11:00",
                "12:00",
                "13:00",
                "14:00",
                "15:00",
                "16:00",
                "17:00",
                "18:00",
                "19:00",
                "20:00",
                "21:00",
                "22:00",
                "23:00"
            ],
            yAxis18Month120: [],
            yAxis18Month7: [],
            yAxis18MonthNoLine: [],
            yAxis18Month2: [],
            yAxis30Month120: [],
            yAxis30Month7: [],
            yAxis30MonthNoLine: [],
            yAxis30Month2: [],
            yAxis24Month120: [],
            yAxis24Month7: [],
            yAxis24MonthNoLine: [],
            yAxis24Month2: [],
            visible: false
        };
    },
    computed: {
        barYear18() {
            const options = {
                grid: {
                    left: "2%",
                    right: "2%",
                    top: "35%",
                    bottom: "5%",
                    containLabel: true
                },
                tooltip: {
                    trigger: "axis"
                },
                legend: {
                    type: "scroll",
                    icon: "circle",
                    data: ["总充电量", "总放电量"],
                    left: "30%",
                    top: "2%",
                    textStyle: { fontSize: 12, color: "#fff" }
                },
                color: ["#DC7904", "#3A85E6"],
                xAxis: [
                    {
                        type: "category",
                        data: this.time18X,
                        axisLabel: {
                            //x轴文字的配置
                            show: true,
                            textStyle: {
                                color: "#999999"
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: "#0c576d" // 颜色
                            }
                        }
                    }
                ],
                yAxis: [
                    {
                        type: "value",
                        name: "电量(kW.h)",
                        axisLabel: {
                            //x轴文字的配置
                            show: true,
                            textStyle: {
                                color: "#999999"
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: "#0c576d" // 颜色
                            },
                            show: false
                        },
                        splitLine: {
                            //分割线配置
                            show: true,
                            lineStyle: {
                                color: "#023F8B"
                            }
                        }
                    }
                ],
                series: [
                    {
                        name: "总充电量",
                        type: "bar",
                        data: this.yAxis18Month120
                    },
                    {
                        name: "总放电量",
                        type: "bar",
                        data: this.yAxis18Month7
                    }
                ]
            };
            return options;
        },
        barYear30() {
            const options = {
                grid: {
                    left: "2%",
                    right: "2%",
                    top: "35%",
                    bottom: "5%",
                    containLabel: true
                },
                legend: {
                    type: "scroll",
                    icon: "circle",
                    data: ["风时发电量", "谷时发电量"],
                    left: "30%",
                    top: "2%",
                    textStyle: { fontSize: 12, color: "#fff" }
                },
                tooltip: {
                    trigger: "axis"
                },
                color: ["#DC7904", "#3A85E6"],
                xAxis: [
                    {
                        type: "category",
                        data: this.time30X,
                        axisLabel: {
                            //x轴文字的配置
                            show: true,
                            textStyle: {
                                color: "#999999"
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: "#0c576d" // 颜色
                            }
                        }
                    }
                ],
                yAxis: [
                    {
                        type: "value",
                        name: "电量(kW.h)",
                        axisLabel: {
                            //x轴文字的配置
                            show: true,
                            textStyle: {
                                color: "#999999"
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: "#0c576d" // 颜色
                            },
                            show: false
                        },
                        splitLine: {
                            //分割线配置
                            show: true,
                            lineStyle: {
                                color: "#023F8B"
                            }
                        }
                    }
                ],
                series: [
                    {
                        name: "风时发电量",
                        type: "bar",
                        data: this.yAxis30Month120
                    },
                    {
                        name: "谷时发电量",
                        type: "bar",
                        data: this.yAxis30Month7
                    }
                ]
            };
            return options;
        },
        barYear() {
            const options = {
                grid: {
                    left: "2%",
                    right: "2%",
                    top: "35%",
                    bottom: "5%",
                    containLabel: true
                },
                legend: {
                    type: "scroll",
                    icon: "circle",
                    data: ["总充电量", "总放电量"],
                    left: "30%",
                    top: "2%",
                    textStyle: { fontSize: 12, color: "#fff" }
                },
                tooltip: {
                    trigger: "axis"
                },
                color: ["#DC7904", "#3A85E6"],
                xAxis: [
                    {
                        type: "category",
                        data: this.time24X,
                        axisLabel: {
                            //x轴文字的配置
                            show: true,
                            textStyle: {
                                color: "#999999"
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: "#0c576d" // 颜色
                            }
                        }
                    }
                ],
                yAxis: [
                    {
                        type: "value",
                        name: "电量(kW.h)",
                        axisLabel: {
                            //x轴文字的配置
                            show: true,
                            textStyle: {
                                color: "#999999"
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: "#0c576d" // 颜色
                            },
                            show: false
                        },
                        splitLine: {
                            //分割线配置
                            show: true,
                            lineStyle: {
                                color: "#023F8B"
                            }
                        }
                    }
                ],
                series: [
                    {
                        name: "总充电量",
                        type: "line",
                        smooth: true,
                        areaStyle: {},
                        symbolSize: 0.1,
                        data: this.yAxis24Month120
                    },
                    {
                        name: "总放电量",
                        type: "line",
                        smooth: true,
                        symbolSize: 0.1,
                        areaStyle: {},
                        data: this.yAxis24Month7
                    }
                ]
            };
            return options;
        },
        pieOption18() {
            const options = {
                grid: {
                    left: "2%",
                    right: "2%",
                    top: "20%",
                    bottom: "5%",
                    containLabel: true
                },
                tooltip: {
                    trigger: "axis"
                },
                // legend: {
                //     type: "scroll",
                //     icon: "circle",
                //     data: ["总充电量", "总放电量"],
                //     left: "30%",
                //     top: "2%",
                //     textStyle: { fontSize: 12, color: "#fff" },
                // },
                color: ["#DC7904", "#56fcff"],
                xAxis: [
                    {
                        type: "category",
                        data: this.time18X,
                        axisLabel: {
                            //x轴文字的配置
                            show: true,
                            textStyle: {
                                color: "#999999"
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: "#0c576d" // 颜色
                            }
                        }
                    }
                ],
                yAxis: [
                    {
                        type: "value",
                        name: "收益(元)",
                        axisLabel: {
                            //x轴文字的配置
                            show: true,
                            textStyle: {
                                color: "#999999"
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: "#0c576d" // 颜色
                            },
                            show: false
                        },
                        splitLine: {
                            //分割线配置
                            show: true,
                            lineStyle: {
                                color: "#023F8B"
                            }
                        }
                    }
                ],
                series: [
                    {
                        name: "总充电量",
                        type: "line",
                        symbolSize: 0.1,
                        data: this.yAxis18Month120
                    },
                    {
                        name: "总放电量",
                        type: "line",
                        symbolSize: 0.1,
                        data: this.yAxis18Month7
                    }
                ]
            };
            return options;
        },
        pieOption30() {
            const options = {
                grid: {
                    left: "2%",
                    right: "2%",
                    top: "20%",
                    bottom: "5%",
                    containLabel: true
                },
                tooltip: {
                    trigger: "axis"
                },
                color: ["#DC7904", "#56fcff"],
                xAxis: [
                    {
                        type: "category",
                        data: this.time30X,
                        axisLabel: {
                            //x轴文字的配置
                            show: true,
                            textStyle: {
                                color: "#999999"
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: "#0c576d" // 颜色
                            }
                        }
                    }
                ],
                yAxis: [
                    {
                        type: "value",
                        name: "收益(元)",
                        axisLabel: {
                            //x轴文字的配置
                            show: true,
                            textStyle: {
                                color: "#999999"
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: "#0c576d" // 颜色
                            },
                            show: false
                        },
                        splitLine: {
                            //分割线配置
                            show: true,
                            lineStyle: {
                                color: "#023F8B"
                            }
                        }
                    }
                ],
                series: [
                    {
                        name: "风时发电量",
                        type: "line",
                        symbolSize: 0.1,
                        data: this.yAxis30Month120
                    },
                    {
                        name: "谷时发电量",
                        type: "line",
                        symbolSize: 0.1,
                        data: this.yAxis30Month7
                    }
                ]
            };
            return options;
        },
        pieOption24() {
            const options = {
                grid: {
                    left: "2%",
                    right: "2%",
                    top: "35%",
                    bottom: "5%",
                    containLabel: true
                },
                tooltip: {
                    trigger: "axis"
                },
                legend: {
                    type: "scroll",
                    icon: "circle",
                    data: ["总充电量", "总放电量"],
                    left: "30%",
                    top: "2%",
                    textStyle: { fontSize: 12, color: "#fff" }
                },
                color: ["#DC7904", "#3A85E6"],
                xAxis: [
                    {
                        type: "category",
                        data: this.time18X,
                        axisLabel: {
                            //x轴文字的配置
                            show: true,
                            textStyle: {
                                color: "#999999"
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: "#0c576d" // 颜色
                            }
                        }
                    }
                ],
                yAxis: [
                    {
                        type: "value",
                        name: "电量(kW.h)",
                        axisLabel: {
                            //x轴文字的配置
                            show: true,
                            textStyle: {
                                color: "#999999"
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: "#0c576d" // 颜色
                            },
                            show: false
                        },
                        splitLine: {
                            //分割线配置
                            show: true,
                            lineStyle: {
                                color: "#023F8B"
                            }
                        }
                    }
                ],
                series: [
                    {
                        name: "总充电量",
                        type: "bar",
                        data: this.yAxis18Month120
                    },
                    {
                        name: "总放电量",
                        type: "bar",
                        data: this.yAxis18Month7
                    }
                ]
            };
            return options;
        }
    },
    created() {
        this.yAxis18Month120 = this.getSeriesData(0, 20, 18);
        this.yAxis18Month7 = this.getSeriesData(0, 20, 18);
        this.yAxis18MonthNoLine = this.getSeriesData(0, 20, 18);
        this.yAxis18Month2 = this.getSeriesData(0, 20, 18);
        let year = new Date().getFullYear();
        let month = new Date().getMonth();
        let dayNum = this.mGetDate(year, month + 1);
        this.time30X = [];
        for (let i = 1; i < dayNum + 1; i++) {
            let date = i < 10 ? "0" + i : i;
            this.time30X[i - 1] = month + 1 + "-" + date;
        }
        this.yAxis30Month120 = this.getSeriesData(0, 20, dayNum);
        this.yAxis30Month7 = this.getSeriesData(0, 20, dayNum);
        this.yAxis30MonthNoLine = this.getSeriesData(0, 20, dayNum);
        this.yAxis30Month2 = this.getSeriesData(0, 20, dayNum);
        this.yAxis24Month120 = this.getSeriesData(0, 20, 24);
        this.yAxis24Month7 = this.getSeriesData(0, 20, 24);
        this.yAxis24MonthNoLine = this.getSeriesData(0, 20, 24);
        this.yAxis24Month2 = this.getSeriesData(0, 20, 24);
    },
    methods: {
        mGetDate(year, month) {
            var d = new Date(year, month, 0);
            return d.getDate();
        },
        getSeriesData(min, max, MathNum) {
            let lineArr = [];
            for (let i = 0; i < MathNum; i++) {
                let value =
                    parseInt(((Math.random() * 100) / 100) * (max - min)) + min;
                lineArr.push(value);
            }
            return lineArr;
        }
    }
};
</script>
<style lang="scss">
.overview-page-container {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: space-between;
    padding: 0 2rem 2rem 2rem;
    box-sizing: border-box;
    position: relative;
    .d3-iframe {
        width: 100%;
        height: 113%;
        margin-top: -1.6rem;
        position: absolute;
        left: 0;
        top: 0;
    }
    .overview-left,
    .overview-right {
        width: 47%;
        height: 100%;
        position: absolute;
        .overview-item {
            width: 100%;
            height: calc((100% - 4rem) / 3);
            margin-bottom: 2rem;
            background: url("../../../assets/image/leaderpage/energy_back.png")
                no-repeat;
            background-size: 100% 100%;
            &:last-child {
                margin-bottom: 0;
            }
            .overview-title {
                font-size: 0.8rem;
                padding-left: 1.8rem;
                padding-top: 0.4rem;
                color: #fff;
            }
            .echart-wrap {
                width: 100%;
                height: calc(100% - 0.8rem - 0.4rem);
                padding: 1rem;
                box-sizing: border-box;
                .echarts {
                    width: 100%;
                    height: 100%;
                }
            }
        }
    }
    .overview-left {
        left: 2rem;
        top: 0;
    }
    .overview-right {
        right: 2rem;
        top: 0;
    }
    .overview-middle {
        height: 100%;
        padding-top: 2rem;
        box-sizing: border-box;
        width: calc(100% - 26rem - 26rem);
        img {
            width: 100%;
            // height: 100%;
        }
    }
}
</style>
